exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".loader{position:absolute;top:calc(50% - 7.5em)}.loader__circle{stroke-width:2}.loader.loader_primary{color:#6D1CF0}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Circle/style.scss
// module id = 1902
// module chunks = 0